import React from 'react';
import { useTranslation } from 'react-i18next';

export const MAX_CART_QUANTITY = 20;

const stepperButtonStyle = (disabled) => ({
  width: 24,
  height: 24,
  padding: 0,
  margin: 0,
  border: '1px solid #D6DCE1',
  background: '#fff',
  borderRadius: 6,
  cursor: disabled ? 'not-allowed' : 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  opacity: disabled ? 0.4 : 1,
  color: '#374151',
  fontSize: 14,
  lineHeight: 1,
  fontWeight: 600
});

const CartQuantityStepper = ({
  quantity,
  disabled,
  onDecrease,
  onIncrease,
  maxQuantity = MAX_CART_QUANTITY
}) => {
  const { t } = useTranslation('ChatbotIA');
  const decreaseDisabled = disabled || quantity <= 1;
  const increaseDisabled = disabled || quantity >= maxQuantity;

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        flexShrink: 0
      }}
    >
      <button
        type="button"
        style={stepperButtonStyle(decreaseDisabled)}
        onClick={onDecrease}
        disabled={decreaseDisabled}
        aria-label={t('cart.playground.decrease_quantity')}
      >
        −
      </button>
      <span
        style={{
          minWidth: 16,
          textAlign: 'center',
          fontSize: 12,
          fontWeight: 600,
          color: '#111827'
        }}
      >
        {quantity}
      </span>
      <button
        type="button"
        style={stepperButtonStyle(increaseDisabled)}
        onClick={onIncrease}
        disabled={increaseDisabled}
        aria-label={t('cart.playground.increase_quantity')}
      >
        +
      </button>
    </div>
  );
};

export default CartQuantityStepper;
